<template>
  <main class="page games-page" ref="root">
    <div class="page__body games-page__body">

      <div class="first-screen offset-section_small first-screen_left">
        <div class="_container">
          <!-- NAVIGATION ============================================= -->
          <BreadCrumbs :links="[{title: 'Games', href: '/client-area/games'}]"
          />
          <!-- NAVIGATION ============================================= END -->

          <!-- PAGE DESCRIPTION ======================================= -->
          <div class="first-screen__body">
            <div class="first-screen__left">
              <div class="page-heading page-heading_colors">
                <h1>
                  <span>KENDOO <em>GAMES</em></span>
                </h1>
              </div>
              <div class="page-description page-description_offset _icon-arrow-2">
                <p>
                  Kendoo portfolio spans classic formats to feature-rich titles, built to meet diverse player demand. Each game is developed to high technical and regulatory standards, ensuring reliable performance and sustained engagement.
                </p>
              </div>
            </div>
            <div class="first-screen__right"></div>
          </div>
          <!-- PAGE DESCRIPTION ======================================= END -->
        </div>
      </div>

      <div class="_container">
        <GamesGrid :user="user"/>
      </div>
    </div>
  </main>
</template>


<script>
import BreadCrumbs from '@/components/breadcrumbs';
import GamesGrid from './games_grid';

export default {
    name: 'Games',
    props: {
        user: Object,
        isClientArea: Boolean,
    },
    components: {
        BreadCrumbs,
        GamesGrid,
    },
}
</script>



